export class Connection {
    firstName: string;
    lastName: string;
    avatar: string;
    initials: string;
}
